import { withPrefix } from 'gatsby'
import routesConfig from 'src/routes.config'
import { scrollIds } from './PageArtificialOS'

export default {
  metadata: {
    title: 'Making insurance frictionless. - artificial',
    desc: 'Our integrated insurance platform allows for world-class data capture, digital contract negotiation and automated risk scoring and pricing.',
  },
  ArHeroHeader: {
    title: 'Making insurance frictionless',
    description: 'We’re digitising the quote, bind and issue process for commercial insurers.',
    cta: {
      label: 'Request a demo',
    },
    videoMobile: {
      alt: '',
      copyright: '',
      type: 'video/mp4',
      src: withPrefix('video/HOME-cropped.mp4'),
    },
    videoTablet: {
      alt: '',
      copyright: '',
      type: 'video/mp4',
      src: withPrefix('video/HOME-cropped.mp4'),
    },
    videoDesktop: {
      alt: '',
      copyright: '',
      type: 'video/mp4',
      src: withPrefix('video/HOME-cropped.mp4'),
    },
  },
  ArPostSimple: {
    title: 'Commercial insurance made simple',
    description: 'We give you the tools to make the quote, bind and issue process frictionless.',
  },
  ArItemsWithDescription: {
    title: 'artificialOS',
    description: 'Our integrated platform allows for world&#8209;class data capture, enables digital contract negotiation and dramatically improves workflow.',
    cta: {
      title: 'Learn more',
      url: routesConfig.artificialOS(),
    },
    items: [
      { title: 'Universal tools', image: withPrefix('img/ArItemsWithDescription1.svg'), link: routesConfig.artificialOS({ hash: scrollIds.universalTools }) },
      { title: 'Contract building and negotiation', image: withPrefix('img/ArItemsWithDescription3.png'), link: routesConfig.artificialOS({ hash: scrollIds.contractBuilding }) },
      { title: 'Data capture and enrichment', image: withPrefix('img/ArItemsWithDescription2.png'), link: routesConfig.artificialOS({ hash: scrollIds.dataCapture }) },
      { title: 'Scoring and pricing', image: withPrefix('img/ArItemsWithDescription4.png'), link: routesConfig.artificialOS({ hash: scrollIds.scoringAndPricing }) },
      { title: 'Policy management', image: withPrefix('img/ArItemsWithDescription5.png'), link: routesConfig.artificialOS({ hash: scrollIds.policyManagement }) },
    ],
  },

  // ArTextWithImage: {
  //   items: [
  //     {
  //       title: {
  //         text: 'We believe in a better insurance experience',
  //       },
  //       description: [
  //         'Right now insurance companies are being slowed down by cumbersome, paper-based processes. As a result, customer experiences have suffered.',
  //         { tag: 'br' },
  //         { tag: 'br' },
  //         'At Artificial we believe insurers like you need flexible, modern and cloud-based tools and your customers deserve to be given delightful user experiences.',
  //       ],
  //       images: [
  //         { url: withPrefix('img/ArTextWithImage2a.png'), alt: 'Artificial Insurtech London' }, // Mobile
  //         { url: withPrefix('img/ArTextWithImage2b.png'), alt: 'Artificial Insurtech London' }, // Tablet
  //         { url: withPrefix('img/ArTextWithImage2c.png'), alt: 'Artificial Insurtech London' }, // Desktop
  //       ],
  //       scImageMargins: {
  //         right: ['-15px', '0'],
  //         bottom: ['40px', '0'],
  //         left: ['-15px', '-42px', '-142px'],
  //       },
  //       scComponentMargins: {
  //         top: ['30px', '80px', '125px'],
  //         bottom: ['40px', '80px', '75px'],
  //       },
  //       scGap: [0, 135, 135],
  //     },
  //   ],
  // },
  ArColumnsWithDescription: {
    title: 'How it works',
    description: 'Find out how we help insurers with our digital platform.',
    columns: [
      {
        image: {
          alt: '',
          url: withPrefix('img/ArColumnsWithDescription5.svg'),
        },
        title: 'Transforming data',
        description:
          'Capture quote data easily. Augment and enrich with internal and external sources.',
        cta: routesConfig.useCases.transformData(),
      },
      {
        image: {
          alt: '',
          url: withPrefix('img/ArColumnsWithDescription6.svg'),
        },
        title: 'Optimising pricing',
        description:
          'Automate the scoring and pricing of risks. Enhance pricing with Machine Learning.',
        cta: routesConfig.useCases.optimisePricing(),
      },
      {
        image: {
          alt: '',
          url: withPrefix('img/ArColumnsWithDescription7.svg'),
        },
        title: 'Distributing digitally',
        description:
          'Integrate with existing systems. Speed up your route to market and delight your customers.',
        cta: routesConfig.useCases.distributeDigitally(),
      },
      {
        image: {
          alt: 'Artificial Manage for insurance',
          url: withPrefix('img/ArColumnsWithDescription8.svg'),
        },
        title: 'Accelerating workflow',
        description:
          'Support administrators with workflow automation. Negotiate contracts digitally.',
        cta: routesConfig.useCases.accelerateWorkflow(),
      },
    ],
  },
}
